var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLamb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.486 2.89165C13.9896 3.11841 14.214 3.71047 13.9873 4.21405L11.831 9.00263C11.6043 9.50621 11.0122 9.73063 10.5086 9.50387C10.005 9.27711 9.78061 8.68504 10.0074 8.18146L12.1636 3.39288C12.3904 2.8893 12.9824 2.66489 13.486 2.89165Z",
    fill: "#E11F53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8276 6.9179C18.0098 7.43926 17.7349 8.00962 17.2135 8.19184L14.3292 9.19989C13.8079 9.38211 13.2375 9.10718 13.0553 8.58582C12.8731 8.06446 13.148 7.4941 13.6694 7.31188L16.5536 6.30383C17.075 6.12161 17.6454 6.39654 17.8276 6.9179Z",
    fill: "#E11F53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7971 10.1658C15.0259 9.66317 15.6188 9.44113 16.1215 9.66991L20.798 11.7983C21.3007 12.027 21.5227 12.62 21.294 13.1227C21.0652 13.6253 20.4722 13.8474 19.9696 13.6186L15.293 11.4902C14.7904 11.2615 14.5683 10.6685 14.7971 10.1658Z",
    fill: "#4C8BF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7749 12.8549C16.2972 12.6754 16.8661 12.9533 17.0456 13.4756L17.9694 16.1638C18.1489 16.6861 17.871 17.255 17.3487 17.4345C16.8264 17.614 16.2575 17.3361 16.078 16.8138L15.1542 14.1256C14.9747 13.6033 15.2526 13.0343 15.7749 12.8549Z",
    fill: "#4C8BF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2285 14.4354C14.7285 14.6699 14.9438 15.2653 14.7093 15.7654L12.3851 20.7219C12.1507 21.222 11.5552 21.4372 11.0552 21.2028C10.5551 20.9683 10.3399 20.3728 10.5743 19.8728L12.8985 14.9163C13.133 14.4162 13.7285 14.2009 14.2285 14.4354Z",
    fill: "#43C6AC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4135 15.372C11.5973 15.8928 11.3241 16.464 10.8033 16.6478L7.94737 17.6559C7.42658 17.8397 6.85537 17.5666 6.67155 17.0458C6.48772 16.525 6.76089 15.9538 7.28169 15.7699L10.1376 14.7619C10.6584 14.5781 11.2296 14.8512 11.4135 15.372Z",
    fill: "#43C6AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2625 10.8606C3.4943 10.3593 4.08858 10.1408 4.58987 10.3726L9.4346 12.6128C9.93588 12.8446 10.1543 13.4389 9.92255 13.9402C9.69075 14.4415 9.09647 14.66 8.59518 14.4282L3.75045 12.1879C3.24917 11.9561 3.03071 11.3618 3.2625 10.8606Z",
    fill: "#F8B233"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22255 6.5302C7.74267 6.34446 8.31487 6.61552 8.50062 7.13564L9.4806 9.87978C9.66634 10.3999 9.39528 10.9721 8.87516 11.1578C8.35505 11.3436 7.78284 11.0725 7.5971 10.5524L6.61712 7.80827C6.43137 7.28815 6.70244 6.71594 7.22255 6.5302Z",
    fill: "#F8B233"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamb);
export default __webpack_public_path__ + "static/media/lamb.b17d14e012a5f94d70dc45e4978e6f61.svg";
export { ForwardRef as ReactComponent };